const progressNotesForm = {
  section: 'PNF',
  topic: 'Progress Notes Form',
  checked: 'true',
  // access: "private",
  color: 'secondary',
  description: '(optional)',
  body: [
    {
      id: "PNF.01",
      shortname: "pnf01",
      name: "Description:",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "text",
      act: "PNF01",
      mandatory: 'true',
      depending: "",
      exception: "",
    },
    {
      id: 'PNF.02',
      shortname: 'pnf02',
      name: 'Period:',
      prevalue: '',
      value: '',      // Start Date
      value2: '',     // Start Time
      value3: '',     // End Time
      disabled: 'false',
      type: 'calendar_range',
      act: 'PNF02',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    // {
    //   id: 'PNF.02',
    //   shortname: 'pnf02',
    //   name: 'Period:',
    //   prevalue: '',
    //   value: '',
    //   value2: '',
    //   disabled: 'false',
    //   // type: "hour_minute",
    //   type: 'calendar_range',
    //   act: 'PNF02',
    //   mandatory: 'true',
    //   depending: '',
    //   exception: '',
    // },
    {
      id: 'PNF.03',
      shortname: 'pnf03',
      mandatory: 'true',
      name: 'Subjective: ',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'editor',
      act: 'PNF03',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'PNF.04',
      shortname: 'pnf04',
      mandatory: 'true',
      name: 'Objective: ',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'editor',
      act: 'PNF04',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'PNF.05',
      shortname: 'pnf05',
      mandatory: 'true',
      name: 'Assessment Diagnosis: ',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'editor',
      act: 'PNF05',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'PNF.06',
      shortname: 'pnf06',
      mandatory: 'true',
      name: 'Plan: ',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'editor',
      act: 'PNF06',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
  ],
};

export default progressNotesForm;
